<template>
    <LayoutSub>
        <SubSection classList="pb-0" v-if="selectedContent">
            <div class="tab_menu mt-0">
                <button
                    v-for="content of mainContent"
                    :key="content.name"
                    :class="{ selected: selectedContent.name === content.name }"
                    @click="changeContent(content)"
                >
                    {{ content.name }}
                </button>
            </div>
            <div class="sub_tab_menus" v-if="selectedContent.subContents">
                <ul>
                    <li
                        v-for="subContent of selectedContent.subContents"
                        :key="subContent.name"
                        :class="{ active: selectedSubContent.name === subContent.name }"
                    >
                        <button @click="changeSubContent(subContent)">
                            {{ subContent.name }}
                        </button>
                    </li>
                </ul>
            </div>
            <section class="content_container">
                <div class="content chart" v-if="selectedSubContent?.name === 'BS(재무상태표)'">
                    <BSChart />
                </div>

                <div class="content chart" v-if="selectedSubContent?.name === 'PL(손익계산서)'">
                    <PLChart />
                </div>

                <div class="content chart" v-if="selectedSubContent?.name === 'CF(현금흐름표)'">
                    <CFChart />
                </div>

                <div class="content chart" v-if="selectedSubContent?.name === '주요지표'">
                    <AnnualizedChart />
                </div>

                <div class="content chart" v-if="selectedSubContent?.name === '주식지표'">
                    <EPSChart />
                </div>

                <div class="content" v-if="selectedContent?.name === 'IR Letter'">
                    <IRLetterPage />
                </div>
                <div class="content infor" v-if="selectedSubContent?.name === '상장현황'">
                    <TableListingInformation />
                </div>
                <div class="content shareholders_meeting" v-if="selectedSubContent?.name === '주주총회'">
                    <ShareholdersMeetingTable />
                </div>
                <div class="content price_infor" v-if="selectedSubContent?.name === '주가정보'">
                    <PriceInforTable />
                </div>
            </section>
        </SubSection>
        <LoadingWrap v-else />
    </LayoutSub>
</template>

<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import TableListingInformation from '@/components/IR/TableListingInformation.vue';
import PriceInforTable from '@/components/IR/PriceInforTable.vue';
import BSChart from '@/components/IR/Chart/BSChart.vue';

import ShareholdersMeetingTable from '@/components/IR/ShareholdersMeetingTable.vue';
import PLChart from '@/components/IR/Chart/PLChart.vue';
import CFChart from '@/components/IR/Chart/CFChart.vue';
import EPSChart from '@/components/IR/Chart/EPSChart.vue';
import AnnualizedChart from '@/components/IR/Chart/AnnualizedChart.vue';
import IRLetterPage from '@/components/IR/IRLetterPage.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';

export default {
    components: {
        SubSection,
        LayoutSub,
        TableListingInformation,
        ShareholdersMeetingTable,
        PriceInforTable,
        BSChart,
        PLChart,
        CFChart,
        AnnualizedChart,
        EPSChart,
        IRLetterPage,
        LoadingWrap,
    },
    data() {
        return {
            selectedContent: null,
            selectedSubContent: null,
            mainContent: [
                {
                    name: '경영실적',
                    subContents: [
                        {
                            name: 'BS(재무상태표)',
                        },
                        {
                            name: 'PL(손익계산서)',
                        },
                        {
                            name: 'CF(현금흐름표)',
                        },
                        {
                            name: '주요지표',
                        },
                        {
                            name: '주식지표',
                        },
                    ],
                },
                {
                    name: '주식',
                    subContents: [
                        {
                            name: '상장현황',
                        },
                        {
                            name: '주주총회',
                        },
                        {
                            name: '주가정보',
                        },
                    ],
                },
                // {
                //     name: 'IR Letter',
                // },
            ],
        };
    },
    mounted() {
        if (this.$route.query.content) {
            this.selectedContent = this.mainContent.find((el) => el.name === this.$route.query.content);

            if (this.selectedContent?.subContents) {
                this.selectedSubContent = this.selectedContent.subContents[0];
            } else {
                this.selectedSubContent = null;
            }
        } else {
            this.changeContent(this.mainContent[0]);
        }
    },
    methods: {
        changeRoute(content) {
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    content: content?.name,
                },
            });
        },
        changeContent(content) {
            this.changeRoute(content);
            this.selectedContent = content;

            if (this.selectedContent?.subContents) {
                this.changeSubContent(this.selectedContent.subContents[0]);
            } else {
                this.changeSubContent(null);
            }
        },
        changeSubContent(content) {
            this.selectedSubContent = content;
        },
    },
};
</script>

<style lang="scss" scoped>
.sub_tab_menus {
    overflow: auto;

    ul {
        width: 100%;
        display: flex;
        border-bottom: 1px solid #e5e5e5;

        li {
            flex: 1 0 140px;
            list-style: none;
            height: 50px;
            justify-content: center;
            align-items: center;

            button {
                width: 100%;
                height: 100%;
                cursor: pointer;
                font-size: 16px;
                font-weight: 400;
                color: #333;

                @media screen and (max-width: 768px) {
                    font-size: 14px;
                }
            }

            &.active {
                button {
                    position: relative;
                    font-weight: 600;
                    color: var(--orange);

                    &::after {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 3px;
                        background: var(--orange);
                        bottom: -1px;
                        left: 0;
                    }
                }
            }
        }
    }
}

.content_container {
    padding-top: 80px;

    @media screen and (max-width: 768px) {
        padding-top: 30px;
    }

    .content {
        position: relative;

        &.infor {
            display: flex;

            @media screen and (max-width: 768px) {
                flex-direction: column;
                gap: 30px;
            }
        }

        &.shareholders_meeting {
            display: flex;
            flex-direction: column;
        }
    }
}
</style>
